interface Props {
    progress: number | null
    isLoading: boolean
    title: string | null
    subtitle: string | null
    smooth?: boolean | null
}

const ProgressBar: React.FC<Props> = ({progress, isLoading, title, subtitle, smooth = true}) => {

    return isLoading && (
        <div className="mt-6 p-4 bg-gray-100 dark:bg-gray-700 rounded-lg">
            <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {title}
                </span>
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {progress !== null ? Math.round(progress * 100) : 0}%
                </span>
            </div>
            <div className="w-full bg-gray-300 dark:bg-gray-600 rounded-full h-2.5">
                <div 
                    className={`bg-blue-600 dark:bg-blue-500 h-2.5 rounded-full ${smooth ? "transition-all duration-300 ease-in-out" : ""}`} 
                    style={{ width: `${progress !== null ? Math.round(progress * 100) : 0}%` }}
                ></div>
            </div>
            <div className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                {subtitle}
            </div>
        </div>
    )
}

export default ProgressBar